export const DATE_FORMAT_WEEK_DAY = {
  day: '2-digit',
  month: '2-digit',
  weekday: 'short',
  timeZone: 'UTC',
};

export const formatBrazilianDateToISODate = (date) => {
  let newDate = date;
  if (newDate && newDate.includes('/')) {
    const splittedDate = newDate.split('/');
    let dateArrayLength = splittedDate.length;

    // missing year it will add current year
    if (dateArrayLength === 2) {
      splittedDate.push(new Date().getUTCFullYear().toString());
      dateArrayLength = splittedDate.length;
    }

    newDate = '';
    for (let i = dateArrayLength - 1; i >= 0; i -= 1) {
      if (i !== dateArrayLength - 1) {
        newDate = newDate.concat('-');
      }
      newDate = newDate.concat(splittedDate[i]);
    }
  }

  return newDate;
};

export function normalizeToDate(date) {
  if (!date) return '';

  let newDate = date;
  newDate = formatBrazilianDateToISODate(newDate);
  newDate = newDate.replace(/(T\d{2}:\d{2}:\d{2}.\d{3}(?:\+\d{4}|Z)?)?$/, '');

  return new Date(`${newDate}T00:00:00.000Z`).toISOString();
}
